// Dependencies
import React, { Component } from 'react';
import { Col, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';

//Containers
import LotteriesPageContainer from './../../containers/Lotteries/LotteriesPageContainer';

//Actions
import { getPageInfo } from './../../reducers/generalReducer';

//images
import Loteria from '../../assets/images/icon-loterie.svg';

//Components
import Breadcrumbs from './../Global/Breadcrumbs/Breadcrumbs';  
import CountdownTimer from './../Global/Header/CountdownTimer';

class Lotteries extends Component {
  render() {
    const { info } = this.props;
    return (
      <Col xs={12} className="homeContainer">
        <CountdownTimer/>
        <Row>
          <Container className="bg-primary">
            <Breadcrumbs />
            <section className="mb-4 px-4 pb-4 border-container">
            <Row>
                <Col xs={12} className="text-center mb-4">
                  <h1 className="first-title color-white">{ info.title }</h1>
                </Col>
                <Col xs={12} className="text-center mb-4">
                  <h2 className="third-title color-white" dangerouslySetInnerHTML={{ __html: info.description }} ></h2>
                </Col>
              </Row>
            </section>
            <section>
              <LotteriesPageContainer />
            </section>
          </Container>
        </Row>
      </Col>
    );
  }
}

const mapStateToProps = (state) => {
  const { loading, error } = state.general.pages;
  return {
    loading,
    error,
    info: getPageInfo(state, 'loterias')
  };
};

export default connect(mapStateToProps)(Lotteries);
